module.exports = __webpack_public_path__ + "img/wicasa-logo.943fb219.svg";